"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themes = exports["default"] = void 0;
var _reactCssThemr = require("react-css-themr");
var _Popover = _interopRequireDefault(require("./Popover"));
// themes
require("./themes/DefaultTheme.css");
var DefaultTheme = {
  "rcTriggerZoomIn": "DefaultTheme__rcTriggerZoomIn___2l7Ib",
  "rcTriggerZoomOut": "DefaultTheme__rcTriggerZoomOut___fsJeC",
  "rc-trigger-popup": "DefaultTheme__rc-trigger-popup___Km01Z",
  "anypoint-portal-active": "DefaultTheme__anypoint-portal-active___1yaWI",
  "anypoint-modal-open": "DefaultTheme__anypoint-modal-open___1Lf6r",
  "rc-trigger-popup-hidden": "DefaultTheme__rc-trigger-popup-hidden___uMgyx",
  "rc-trigger-popup-zoom-enter": "DefaultTheme__rc-trigger-popup-zoom-enter___2UwgW",
  "rc-trigger-popup-zoom-appear": "DefaultTheme__rc-trigger-popup-zoom-appear___1hfvB",
  "rc-trigger-popup-zoom-leave": "DefaultTheme__rc-trigger-popup-zoom-leave___3QZeS",
  "rc-trigger-popup-zoom-enter-active": "DefaultTheme__rc-trigger-popup-zoom-enter-active___2Iqoa",
  "rc-trigger-popup-zoom-appear-active": "DefaultTheme__rc-trigger-popup-zoom-appear-active___2vz03",
  "rc-trigger-popup-zoom-leave-active": "DefaultTheme__rc-trigger-popup-zoom-leave-active___f_hmt",
  "alignment-override": "DefaultTheme__alignment-override___2ldnS",
  "target-tl": "DefaultTheme__target-tl___1kpu9",
  "popup-tl": "DefaultTheme__popup-tl___1dH_M",
  "menu-title-container": "DefaultTheme__menu-title-container___1qnrF",
  "popoverContent": "DefaultTheme__popoverContent___22VDT",
  "popoverFixed": "DefaultTheme__popoverFixed___3dOYc",
  "triggerWrapper": "DefaultTheme__triggerWrapper___2mIRR",
  "rcTriggerPopup": "DefaultTheme__rc-trigger-popup___Km01Z",
  "anypointPortalActive": "DefaultTheme__anypoint-portal-active___1yaWI",
  "anypointModalOpen": "DefaultTheme__anypoint-modal-open___1Lf6r",
  "rcTriggerPopupHidden": "DefaultTheme__rc-trigger-popup-hidden___uMgyx",
  "rcTriggerPopupZoomEnter": "DefaultTheme__rc-trigger-popup-zoom-enter___2UwgW",
  "rcTriggerPopupZoomAppear": "DefaultTheme__rc-trigger-popup-zoom-appear___1hfvB",
  "rcTriggerPopupZoomLeave": "DefaultTheme__rc-trigger-popup-zoom-leave___3QZeS",
  "rcTriggerPopupZoomEnterActive": "DefaultTheme__rc-trigger-popup-zoom-enter-active___2Iqoa",
  "rcTriggerPopupZoomAppearActive": "DefaultTheme__rc-trigger-popup-zoom-appear-active___2vz03",
  "rcTriggerPopupZoomLeaveActive": "DefaultTheme__rc-trigger-popup-zoom-leave-active___f_hmt",
  "alignmentOverride": "DefaultTheme__alignment-override___2ldnS",
  "targetTl": "DefaultTheme__target-tl___1kpu9",
  "popupTl": "DefaultTheme__popup-tl___1dH_M",
  "menuTitleContainer": "DefaultTheme__menu-title-container___1qnrF"
};
require("./themes/DarkTheme.css");
var DarkTheme = {
  "popoverContent": "DarkTheme__popoverContent___urrUF"
};
var themes = exports.themes = {
  DefaultTheme: DefaultTheme,
  DarkTheme: DarkTheme
};
var ThemedComponent = (0, _reactCssThemr.themr)('Popover', themes.DefaultTheme)(_Popover["default"]);
ThemedComponent.displayName = 'Popover';
ThemedComponent.themes = themes;
var _default = exports["default"] = ThemedComponent;
//# sourceMappingURL=index.js.map